export abstract class AppError extends Error {
  action?: string;

  constructor(message: string, action?: string) {
    super(message);
    this.action = action;
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
